const PUBLIC_ICON_URL = "https://glimmr.app/images/icon.png";
const PUBLIC_GOOGLE_ANALYTICS_ID = "glimmr-site";
const PUBLIC_GOOGLE_ANALYTICS_TAG = "G-MRTNWGD34M";
export {
  PUBLIC_ICON_URL as P,
  PUBLIC_GOOGLE_ANALYTICS_ID as a,
  PUBLIC_GOOGLE_ANALYTICS_TAG as b
};
